import { UseMutationResult, useMutation } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { IEntitySchema, api } from "../../utils";

export interface IUpdateEntitySchemaParameter {
    name: string;
    description: string;
    schemaId: string;
}

export const useUpdateEntitySchema = (
    queryKey: string | string[],
): UseMutationResult<IEntitySchema, unknown, IUpdateEntitySchemaParameter> => {
    const auth = useAuth();
    return useMutation({
        mutationFn: async (parameters: IUpdateEntitySchemaParameter) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot update entity schema without authorization token.",
                );
            }

            return await api.EntitySchema.update({
                ...parameters,
                token: auth.token,
            });
        },
    });
};
